// the main container's Alpine object
window.appMain = () => {
    return {
        mobileMenu: false,
        loading: false,
        debugExpanded: true,
    }
}
